import React, {PropTypes} from 'react';
import QuestionList from './QuestionList';
import TagBreadcrumb from './components/TagBreadcrumb';

const Home = ({
  getQuestions,
  questions,
  user,
  order,
  tag,
  offset,
  limit,
  total,
  widget,
  context,
}) => {
  let content;
  if (!questions || questions.length === 0) {
    content = (
      <div className="text-center">
        <h1 className="heading heading--bold margin-bottom-md">Welcome, why not create a question to get started?</h1>
      </div>
    );
  } else {
    content = (
      <QuestionList questions={questions} user={user} widget={widget} selectedTag={tag} />
    );
  }

  const tagContent = tag && <TagBreadcrumb tag={tag} />;

  const hasMore = questions && (total > offset + questions.length);
  const loadMoreQuestions = (e) => {
    e.preventDefault();
    const appendResults = true;
    getQuestions(order, tag, context, offset + limit, limit, appendResults);
  };

  return (
    <div>
      {tagContent}
      {content}
      {hasMore &&
      <div className="text-center">
        <button type="button" className="t-home-show-more tes-btn tes-btn--secondary tes-btn--sm" onClick={loadMoreQuestions}>
          Show more ...
        </button>
      </div>}
    </div>
  );
};

Home.propTypes = {
  getQuestions: PropTypes.func.isRequired,
  questions: PropTypes.array,
  user: PropTypes.object,
  tag: PropTypes.string,
  widget: PropTypes.bool,
  order: PropTypes.string.isRequired,
  offset: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  context: PropTypes.string.isRequired,
  showHomeClick: PropTypes.func.isRequired,
};

export default Home;
